module.exports = __webpack_public_path__ + "static/transports-in-japan-main-55faadc8689c7262a5095d4a0be195b5.jpg";